/**
 * optionLabels.ts
 *
 * Zentrale Werte-Listen der Inflations- und Rendite-Optionen sowie kompakte
 * deutsche Kurzlabels für tabellarische Darstellungen (z.B. Szenario-Matrix).
 *
 * Die langen, satzlangen Label-Helfer in `SimpleSimulationControls.tsx` bleiben
 * bewusst lokal und werden NICHT refactored — sie dienen der ausführlichen
 * Beschreibung im Konfigurations-UI. Hier geht es nur um platzsparende Kürzel.
 */

// Die vier Inflations-Optionen (Werte identisch zu SimpleSimulationControls).
export const INFLATION_OPTIONS: string[] = [
  'keine-inflation',
  'parameter-inflation',
  'historische-inflation',
  'statistisch-inflation',
];

// Die sechs Rendite-Optionen des Investitionstopfs (Werte identisch zu
// SimpleSimulationControls). GARCH-Optionen stehen bewusst am Ende, damit die
// Szenario-Matrix sie zusammenhängend abarbeiten kann (Kalibrierungs-Cache).
export const INVESTMENT_RETURN_OPTIONS: string[] = [
  'keine-rendite',
  'konstante-rendite',
  'historische-rendite',
  'statistisch-rendite',
  'historische-garch',
  'statistisch-garch',
];

/**
 * Kompaktes deutsches Kurzlabel für eine Inflations-Option.
 */
export function getInflationShortLabel(option: string): string {
  switch (option) {
    case 'keine-inflation':
      return 'Keine';
    case 'parameter-inflation':
      return 'Parameter';
    case 'historische-inflation':
      return 'Historisch';
    case 'statistisch-inflation':
      return 'Statistisch';
    default:
      return option;
  }
}

/**
 * Kompaktes deutsches Kurzlabel für eine Rendite-Option.
 */
export function getInvestmentReturnShortLabel(option: string): string {
  switch (option) {
    case 'keine-rendite':
      return 'Keine';
    case 'konstante-rendite':
      return 'Parameter';
    case 'historische-rendite':
      return 'Historisch';
    case 'statistisch-rendite':
      return 'Statistisch';
    case 'historische-garch':
      return 'GARCH hist.';
    case 'statistisch-garch':
      return 'GARCH stat.';
    default:
      return option;
  }
}
